export default __webpack_public_path__ + "static/media/420c5f73447c0f06bacfd9b09ba3ead51602962755274.1fbefda2.webp";